// import { BrowserRouter, Routes, Route } from 'react-router-dom';

// import { CartProvider }     from './context/CartContext';
// import { WishlistProvider } from './context/WishlistContext';
// import { CurrencyProvider } from './context/CurrencyContext';
// import { UIProvider }       from './context/UIContext';
// import { AuthProvider }     from './context/AuthContext';

// import Header         from './components/layout/Header';
// import Footer         from './components/layout/Footer';
// import MobileNav      from './components/layout/MobileNav';
// import CartDrawer     from './components/cart/CartDrawer';
// import CheckoutDrawer from './components/cart/CheckoutDrawer';
// import QuickViewModal from './components/product/QuickViewModal';
// import SearchOverlay  from './components/ui/SearchOverlay';
// import EnquiryModal   from './components/ui/EnquiryModal';
// import LeadPopup from './components/ui/LeadPopup';
// import PageTransition from './components/ui/PageTransition'; 

// import HomePage       from './screens/HomePage';
// import ShopPage       from './screens/ShopPage';
// import SellPage from './screens/SellPage';
// import BrandsPage     from './screens/BrandsPage';
// import CategoriesPage from './screens/Categoriespage';
// import AboutPage      from './screens/AboutPage';
// import WishlistPage   from './screens/WishlistPage';
// import BlogsPage      from './screens/BlogsPage';
// import BlogDetails    from './screens/BlogDetails';
// import AdminLogin     from './screens/AdminLogin';
// import AdminPanel     from './screens/AdminPanel';
// import WhatsAppButton from './screens/WhatsAppButton';
// import ScrollToTop from './screens/Scrolltotop';
// export default function App() {
//   return (
//     <BrowserRouter>
      
//       <AuthProvider>
//         <CartProvider>
//           <WishlistProvider>
//             <CurrencyProvider>
//               <UIProvider>
//                 <Routes>
//                   {/* Admin routes — no storefront shell */}
//                   <Route path="/admin/login" element={<AdminLogin />} />
//                   <Route path="/admin"       element={<AdminPanel />} />
//                   <Route path="/admin/*"     element={<AdminPanel />} />

//                   {/* Storefront routes */}
//                   <Route path="/*" element={
//                     <>
//                       <ScrollToTop /> 
//                       <Header />
//                       {/* <main> */}
//                       <main style={{ width: '100%', maxWidth: '100%', overflowX: 'hidden' }}>
//                         <Routes>
//                           <Route path="/"             element={<HomePage />} />
//                           <Route path="/shop"         element={<ShopPage />} />
//                           <Route path="/sell"         element={<SellPage />} />
//                           <Route path="/brands"       element={<BrandsPage />} />
//                           <Route path="/categories"   element={<CategoriesPage />} />
//                           <Route path="/about"        element={<AboutPage />} />
//                           <Route path="/wishlist"     element={<WishlistPage />} />
//                           <Route path="/blogs"        element={<BlogsPage />} />
//                           <Route path="/blogs/:slug"  element={<BlogDetails />} />
//                         </Routes>
//                       </main>
//                       <Footer />
//                       <CartDrawer />
//                       <CheckoutDrawer />
//                       <QuickViewModal />
//                       <SearchOverlay />
//                       <LeadPopup />
//                       <EnquiryModal />
//                       <MobileNav />
//                       <WhatsAppButton />
//                       <ScrollToTop />
//                     </>
//                   } />
//                 </Routes>
//               </UIProvider>
//             </CurrencyProvider>
//           </WishlistProvider>
//         </CartProvider>
//       </AuthProvider>
//     </BrowserRouter>
//   );
// }

import { BrowserRouter, Routes, Route } from 'react-router-dom';

import { CartProvider }     from './context/CartContext';
import { WishlistProvider } from './context/WishlistContext';
import { CurrencyProvider } from './context/CurrencyContext';
import { UIProvider }       from './context/UIContext';
import { AuthProvider }     from './context/AuthContext';

import Header         from './components/layout/Header';
import Footer         from './components/layout/Footer';
import MobileNav      from './components/layout/MobileNav';
import CartDrawer     from './components/cart/CartDrawer';
import CheckoutDrawer from './components/cart/CheckoutDrawer';
import QuickViewModal from './components/product/QuickViewModal';
import SearchOverlay  from './components/ui/SearchOverlay';
import EnquiryModal   from './components/ui/EnquiryModal';
import LeadPopup      from './components/ui/LeadPopup';
import PageTransition from './components/ui/PageTransition';  // ← NEW

import HomePage       from './screens/HomePage';
import ShopPage       from './screens/ShopPage';
import SellPage       from './screens/SellPage';
import BrandsPage     from './screens/BrandsPage';
import CategoriesPage from './screens/Categoriespage';
import AboutPage      from './screens/AboutPage';
import WishlistPage   from './screens/WishlistPage';
import BlogsPage      from './screens/BlogsPage';
import BlogDetails    from './screens/BlogDetails';
import AdminLogin     from './screens/AdminLogin';
import AdminPanel     from './screens/AdminPanel';
import WhatsAppButton from './screens/WhatsAppButton';
import ScrollToTop    from './screens/Scrolltotop';

// Add these imports at the top
import TermsPage    from './screens/TermsPage';
import PrivacyPage  from './screens/PrivacyPage';

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <CartProvider>
          <WishlistProvider>
            <CurrencyProvider>
              <UIProvider>
                <Routes>
                  {/* Admin routes — no storefront shell */}
                  <Route path="/admin/login" element={<AdminLogin />} />
                  <Route path="/admin"       element={<AdminPanel />} />
                  <Route path="/admin/*"     element={<AdminPanel />} />

                  {/* Storefront routes */}
                  <Route path="/*" element={
                    <>
                      <ScrollToTop />
                      <Header />
                      <main style={{ width: '100%', maxWidth: '100%', overflowX: 'hidden' }}>
                        {/* ↓ PageTransition wraps only the route content */}
                        <PageTransition>
                          <Routes>
                            <Route path="/"            element={<HomePage />} />
                            <Route path="/shop"        element={<ShopPage />} />
                            <Route path="/sell"        element={<SellPage />} />
                            <Route path="/brands"      element={<BrandsPage />} />
                            <Route path="/categories"  element={<CategoriesPage />} />
                            <Route path="/about"       element={<AboutPage />} />
                            <Route path="/wishlist"    element={<WishlistPage />} />
                            <Route path="/blogs"       element={<BlogsPage />} />
                            <Route path="/blogs/:slug" element={<BlogDetails />} />
                            <Route path="/terms"   element={<TermsPage />} />
                            <Route path="/privacy" element={<PrivacyPage />} />
                          </Routes>
                        </PageTransition>
                      </main>
                      <Footer />
                      <CartDrawer />
                      <CheckoutDrawer />
                      <QuickViewModal />
                      <SearchOverlay />
                      <LeadPopup />
                      <EnquiryModal />
                      <MobileNav />
                      <WhatsAppButton />
                    </>
                  } />
                </Routes>
              </UIProvider>
            </CurrencyProvider>
          </WishlistProvider>
        </CartProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}